import React, { useEffect, useState } from 'react';
import styles from './MileageAnalysisTab_bus.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import ChartLoader from './ChartLoader'
import { useVehicleData } from './context';



function TooltipTableModal({ data, globalFilter, selectedVehicleData, benchmarkType }) {
  const { firstVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { key, label } = data
  const { GlobalData, setGlobalData, handleDownloadAllReport } = useVehicleData();



  const [vehicleData, setVehicleData] = useState({})


  const output = Object.entries(vehicleData).map(([label, values]) => ({
    label,
    ...values
  }));


  useEffect(() => {
    let ApiUrl = ""
    let filterObj = {
      ...globalFilter,
      "VIN_NUM": [firstVinNo.vehicleId],
    }

    if (benchmarkType == "Custom") {
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_accelaration_pedal_table',
        RPM: "mileage_analysis_RPM_table"

      }
      ApiUrl = apis[key] || ""
    }
    if (benchmarkType == "National") {
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_national_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_national_accelaration_pedal_table',
        RPM: "mileage_analysis_national_RPM_table"
      }
      ApiUrl = apis[key] || ""

      filterObj.NATIONAL_VIN_NUM = GlobalData?.nationalVehicleDetails?.vehicleId ? [GlobalData?.nationalVehicleDetails?.vehicleId] : []
    }
    if (benchmarkType == "Fleet") {
      let apis = {
        vehicleSpeedDistribution: 'mileage_analysis_fleet_vehicle_speed_distribution_table',
        accPedalPosition: 'mileage_analysis_fleet_accelaration_pedal_table',
        RPM: "mileage_analysis_fleet_RPM_table"
      }
      ApiUrl = apis[key] || ""

      filterObj.FLEET_VIN_NUM = GlobalData?.fleetVehicleDetails?.vehicleId ? [GlobalData?.fleetVehicleDetails?.vehicleId] : []
    }
    setVehicleData([])
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${ApiUrl}`,
        body: {
          filterdata: {
            ...filterObj
          }
        }
      },
      (res) => {

        let selectedDay = res?.selectedDay || {}
        let bestDay = res?.bastDay || res?.bestDay || {}
        let national = res?.national || {}
        let fleet = res?.national || {}

        if (key == "vehicleSpeedDistribution") {

          setVehicleData(prevState => ({
            '0-10': { ...prevState['0-10'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_0_10?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_0_10?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_0_10?.value).toFixed(2) ?? null, fleet: Number(fleet?.Vehicle_Speed_Distribution_0_10?.value).toFixed(2) ?? null },
            '10-20': { ...prevState['10-20'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_10_20?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_10_20?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_10_20?.value).toFixed(2) ?? null, fleet: Number(fleet?.Vehicle_Speed_Distribution_10_20?.value).toFixed(2) ?? null },
            '20-40': { ...prevState['20-40'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_20_40?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_20_40?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_20_40?.value).toFixed(2) ?? null, fleet: Number(fleet?.Vehicle_Speed_Distribution_20_40?.value).toFixed(2) ?? null },
            '40-50': { ...prevState['40-50'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_40_50?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_40_50?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_40_50?.value).toFixed(2) ?? null, fleet: Number(fleet?.Vehicle_Speed_Distribution_40_50?.value).toFixed(2) ?? null },
            '50-60': { ...prevState['50-60'], primaryVehicle: Number(selectedDay?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, national: Number(national?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null, fleet: Number(fleet?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? null },
            '60+': { ...prevState['60+'], primaryVehicle: Number(selectedDay?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, national: Number(national?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null, fleet: Number(fleet?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? null },
          }));
        }
        else if (key == "accPedalPosition") {

          setVehicleData(prevState => ({
            '0-10': { ...prevState['0-10'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_0_10?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_0_10?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_0_10?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_0_10?.value).toFixed(2) ?? null, },
            '10-30': { ...prevState['10-30'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_10_30?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_10_30?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_10_30?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_10_30?.value).toFixed(2) ?? null, },
            '30-40': { ...prevState['30-40'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_30_40?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_30_40?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_30_40?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_30_40?.value).toFixed(2) ?? null, },
            '40-50': { ...prevState['40-50'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_40_50?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_40_50?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_40_50?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_40_50?.value).toFixed(2) ?? null, },
            '50-60': { ...prevState['50-60'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_50_60?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_50_60?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_50_60?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_50_60?.value).toFixed(2) ?? null, },
            '60+': { ...prevState['60+'], primaryVehicle: Number(selectedDay?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.best_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, national: Number(national?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, fleet: Number(fleet?.selected_Accelarator_Pedal_60_plus?.value).toFixed(2) ?? null, },
          }));

        }
        else {
          setVehicleData(prevState => ({
            '0-2000': { ...prevState['0-2000'], primaryVehicle: Number(selectedDay?.RPM_0_2000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_0_2000?.value).toFixed(2) ?? null, national: Number(national?.RPM_0_2000?.value).toFixed(2) ?? null, fleet: Number(fleet?.RPM_0_2000?.value).toFixed(2) ?? null, },
            '2000-3000': { ...prevState['2000-3000'], primaryVehicle: Number(selectedDay?.RPM_2000_3000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_2000_3000?.value).toFixed(2) ?? null, national: Number(national?.RPM_2000_3000?.value).toFixed(2) ?? null, fleet: Number(fleet?.RPM_2000_3000?.value).toFixed(2) ?? null, },
            '3000-5000': { ...prevState['3000-5000'], primaryVehicle: Number(selectedDay?.RPM_3000_5000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_3000_5000?.value).toFixed(2) ?? null, national: Number(national?.RPM_3000_5000?.value).toFixed(2) ?? null, fleet: Number(fleet?.RPM_3000_5000?.value).toFixed(2) ?? null, },
            '5000-6000': { ...prevState['5000-6000'], primaryVehicle: Number(selectedDay?.RPM_5000_6000?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_5000_6000?.value).toFixed(2) ?? null, national: Number(national?.RPM_5000_6000?.value).toFixed(2) ?? null, fleet: Number(fleet?.RPM_5000_6000?.value).toFixed(2) ?? null, },
            '6000+': { ...prevState['6000+'], primaryVehicle: Number(selectedDay?.RPM_6000_plus?.value).toFixed(2) ?? null, bestVehicle: Number(bestDay?.RPM_6000_plus?.value).toFixed(2) ?? null, national: Number(national?.RPM_6000_plus?.value).toFixed(2) ?? null, fleet: Number(fleet?.RPM_6000_plus?.value).toFixed(2) ?? null, },
          }));
        }
      }
    );


  }, [globalFilter, GlobalData?.fleetVehicleDetails?.vehicleId, GlobalData?.nationalVehicleDetails?.vehicleId, firstVinNo, key, benchmarkType])


  return (
    <div>
      {/* <div id="tooltipModal_MSbus" className="modal fade" role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-capitalize">{label}</h5>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div> */}
      <div className="modal-body p-0" >
        <div className={styles.tooltipTableContainer} style={{ overflowY: "scroll", height: "300px", position: 'relative' }}>
          <table className={`table table-striped ${styles.tooltipTable}`}>
            <thead>
              <tr className={styles.tooltipTableHeader}>
                <th className={styles.tooltipTableHeaderCell}>Sr. No.</th>
                <th className={styles.tooltipTableHeaderCell}>{label}</th>
                <th className={styles.tooltipTableHeaderCell}>Selected Vehicle</th>
                <th className={styles.tooltipTableHeaderCell}>Best Driven Day</th>
                {benchmarkType === 'National' && (
                  <th className={styles.tooltipTableHeaderCell}>National</th>
                )}
                {benchmarkType === 'Fleet' && (
                  <th className={styles.tooltipTableHeaderCell}>&nbsp;&nbsp;&nbsp;Fleet&nbsp;&nbsp;&nbsp;</th>
                )}
              </tr>
            </thead>
            <tbody>
              {isLoading ? <ChartLoader /> : output?.map((item, index) => (
                <tr key={index}>
                  <td className={styles.tooltipTableCell}>{index + 1}</td>
                  <td className={styles.tooltipTableCell}>{item.label}</td>
                  <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                    {item?.primaryVehicle && !isNaN(item?.primaryVehicle) ? <>{item.primaryVehicle + " %"}</> : "NA"}
                  </td>
                  <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                    {item?.bestVehicle && !isNaN(item?.bestVehicle) ? <>{item.bestVehicle + " %"}</> : "NA"}
                  </td>
                  {benchmarkType === 'National' && (
                    <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                      {item?.national && !isNaN(item?.national) ? <>{item?.national + " %"}</> : "NA"}
                    </td>
                  )}
                  {benchmarkType === 'Fleet' && (
                    <td className={`${styles.tooltipTableCell} ${styles.tooltipValueCell}`}>
                      {item?.fleet && !isNaN(item?.fleet) ? <>{item?.fleet + " %"}</> : "NA"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* <div className="modal-footer p-2">
              <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default TooltipTableModal;

// import React from 'react';
// import Plot from 'react-plotly.js';

// const WaterfallChart = () => {
//   const labels = [
//     'Average<br>Speed',
//     'Vehicle<br>Speed<br>Distribution',
//     'Acc.<br>Pedal<br>Position',
//     'Harsh<br>Acceleration',
//     'Harsh<br>Braking',
//     'Rash<br>Turning',
//     'Over<br>speeding',
//     'Driving<br>Score',
//     'Idling',
//     'Coasting',
//     'Regen<br>eration',
//     'RPM'
//   ];

//   const values = [-0.15, 0.08, -0.12, -0.18, -0.25, -0.10, -0.20, 0.45, -0.30, 0.15, 0.25, 0.08];

//   // Colors for bars and text
//   const barColors = values.map(val => (val >= 0 ? 'green' : 'crimson'));
//   const labelsAbove = values.map(val => (val >= 0 ? `+${val.toFixed(2)}` : `${val.toFixed(2)}`));
//   const textColors = values.map(val => (val >= 0 ? 'green' : 'crimson'));

//   return (
//     <div style={{ width: '100%' }}>
//       <Plot
//         data={[
//           {
//             type: 'bar',
//             x: labels,
//             y: values,
//             marker: { color: barColors },
//             text: labelsAbove,
//             textposition: 'outside',
//             hoverinfo: 'x+y',
//             textfont: {
//               color: textColors,
//               size: 14,
//             },
//           }
//         ]}
//         layout={{
//           barmode: 'relative',
//           bargap: 0.3,
//           autosize: true,
//           xaxis: {
//             tickangle: 0,
//             automargin: true,
//             tickfont: {
//               size: 12,
//             },
//           },
//           yaxis: {
//             showticklabels: false,
//             showgrid: false,
//             zeroline: false, // remove default zero line
//           },
//           shapes: [
//             {
//               type: 'line',
//               xref: 'paper',
//               x0: 0,
//               x1: 1,
//               yref: 'y',
//               y0: 0,
//               y1: 0,
//               line: {
//                 color: 'gray',
//                 width: 1,
//                 dash: 'dot', // dashed X axis line
//               },
//             }
//           ],
//           margin: {
//             t: 30,
//             b: 100,
//             l: 30,
//             r: 30,
//           },
//         }}
//         useResizeHandler={true}
//         style={{ width: '100%', height: '100%' }}
//         config={{ responsive: true, displayModeBar: false, staticPlot: true }}
//       />
//     </div>
//   );
// };

// export default WaterfallChart;






